module.exports = __webpack_public_path__ + "static/media/OTP.ff44f835.svg";